import type { ButtonProps } from '@chakra-ui/react';
import { useLingui } from '@lingui/react/macro';

import { CloseIcon } from './Icon/Close';
import { IconButton } from './IconButton';

export type CloseButtonProps = ButtonProps & {
  ref?: React.RefObject<HTMLButtonElement | null>;
};

/**
 * Крестик закрытия.
 *
 * Имя кнопки задаётся здесь, а не на каждом вызове: их десятки, и раньше все они звучали
 * скринридеру как английское «Close» даже в русской локали — единственный непереведённый
 * элемент шторок. Вызывающий может перебить имя своим `aria-label`, поэтому дефолт стоит
 * до `...props`.
 */
export const CloseButton = ({ children, ref, ...props }: CloseButtonProps) => {
  const { t } = useLingui();

  return (
    <IconButton variant="ghost" aria-label={t`Close`} ref={ref} {...props}>
      {children ?? <CloseIcon />}
    </IconButton>
  );
};
